import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import React, { useState } from 'react'
interface ToggablePasswordProps {
  id: string
  name: string
  label: string
  containerClassName: string
}

export default function ToggablePassword({
  id,
  name = 'password',
  label,
  containerClassName,
}) {
  const [value, setValue] = useState('')
  const [passwordVisible, setPasswordVisible] = useState(false)

  return (
    <div className={`password-field ${containerClassName}`}>
      <input
        name={name}
        id={id}
        type={passwordVisible ? 'text' : 'password'}
        autoComplete='current-password'
        placeholder=' '
        value={value}
        onChange={(e) => setValue(e.target.value)}
        required
        aria-required
      />
      <label htmlFor={id}>{label}</label>

      <div className='toggler'>
        <input
          id={`show_${id}`}
          type='checkbox'
          className='visually-hidden'
          defaultChecked={passwordVisible}
        />
        <label
          htmlFor={`show_${id}`}
          onClick={togglePasswordVisibility}
          className={`toggler-label${value.length > 0 ? ' toggler-label--has-value' : ''}`}
        >
          {passwordVisible ? <Visibility /> : <VisibilityOff />}
          <span className='visually-hidden'>
            {passwordVisible ? 'Masquer' : 'Afficher'} le mot de passe
          </span>
        </label>
      </div>
    </div>
  )

  function togglePasswordVisibility() {
    setPasswordVisible(!passwordVisible)
  }
}
